import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";
import { LocalDataService } from "../../../../../../modules/shared/services/local-data.service";
import { ActivatedRoute, Router } from "@angular/router";
import { cloneDeep } from "lodash";
@Component({
    selector: "asset-config",
    templateUrl: "./assets-config.view.html",
    providers: []
})
export class AssetConfigView implements OnInit {
    assetList: Array<any> = [];
    firstassetList: Array<any> = [];
    secondAssetList: Array<any> = [];
    thirdAssetList: Array<any> = [];
    baseUrl = "";
    assetConfig: any = {};
    additionalFileFields = [
        {
            "label": "Abstract File",
            "key": "{@ddf.abstractFile@}",
            "type": "SESSION"
        },
        {
            "label": "Presentations",
            "key": "{@ddf.presentations@}",
            "type": "SESSION"
        }
    ]

    constructor(
        public sharedService: SharedService,
        private localDataService: LocalDataService,
        private activatedRoute: ActivatedRoute,
        private router: Router
    ) { }

    ngOnInit() {
        if (this.activatedRoute.parent.routeConfig.path == "session") {
            this.baseUrl = this.sharedService.sessionUrl;
            if(!this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig[
                this.sharedService.expansionStyle
            ].hasOwnProperty('assetConfig')) {
                this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig[
                    this.sharedService.expansionStyle
                ].assetConfig = this.sharedService.assetConfig;
            }

            this.assetConfig = this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig[
                this.sharedService.expansionStyle
            ].assetConfig;
            this.sharedService.sessionCustomFields.forEach((cf) => {
                if (cf.questionTypeId == 19) {
                    this.assetList.push({
                        label: cf.name,
                        key: "{@ddf.customFieldMap." + cf.code.replace(/ /g, "") + "@}",
                        type: "file",
                        show: true
                    });
                } else if (cf.questionTypeId == 1 && (cf.name.toLowerCase().includes("url") || cf.code.toLowerCase().includes("url"))) {
                    this.assetList.push({
                        label: cf.name,
                        key: "{@ddf.customFieldMap." + cf.code.replace(/ /g, "") + "@}",
                        type: "text_url",
                        show: true
                    });
                }
            });
            this.additionalFileFields.forEach((cf) => {
                this.assetList.push({
                    label: cf.label,
                    key: cf.key,
                    type: cf.type,
                    show: true
                })
            });
            this.firstassetList = cloneDeep(this.assetList);
            this.secondAssetList = cloneDeep(this.assetList);
            this.thirdAssetList = cloneDeep(this.assetList);

            this.assetConfig.firstGroupList.forEach(element => {
                this.checkIndex('secondAssetList','thirdAssetList',element.value);
            });

            this.assetConfig.secondGroupList.forEach(element => {
                this.checkIndex('firstassetList','thirdAssetList',element.value);
            });

            this.assetConfig.thirdGroupList.forEach(element => {
                this.checkIndex('firstassetList','secondAssetList',element.value);
            });
        }
    }

    onChange(field, key) {
        let index = this.assetConfig[key].findIndex(x => x.value === field.key)
        if(index >= 0) {
            this.removeFields(index,this.assetConfig[key]);
        } else {
            this.assetConfig[key].push({'label':field.label, 'value':field.key, 'type':field.type})
        }
        this.removeFromAssetList(field.key, key);
    }

    removeFromAssetList(value, key) {
        if(key == 'firstGroupList') {
            this.checkIndex('secondAssetList','thirdAssetList',value);
        }

        if(key == 'secondGroupList') {
            this.checkIndex('firstassetList','thirdAssetList',value);
        }

        if(key == 'thirdGroupList') {
            this.checkIndex('firstassetList','secondAssetList',value);
        }
    }

    getIndex(arr,field) {
        return arr.findIndex(x => x.value ===field.key) >=0 ? true: false;
    }

    removeFields(i, list, key = '', value = '') {
        list.splice(i, 1);
        this.removeFromAssetList(value,key);
    }

    checkIndex(list_a,list_b,value) {
        let a = this[list_a].findIndex(x => x.key === value)
        this[list_a][a].show = !this[list_a][a].show;
        let b = this[list_b].findIndex(x => x.key === value)
        this[list_b][b].show = !this[list_b][b].show;
    }

    toggleHTMLEnable(e,key) {
        this.assetConfig[key] = !this.assetConfig[key];
        if(this.assetConfig[key] == false) {
            let list;
            let elem;
            switch(key) {
                case 'enableFirstGroup':
                    list = this.assetConfig.firstGroupList;
                    elem = 'firstGroupList';
                    this.assetConfig.firstGroupList = [];
                  break;
                case 'enableSecondGroup':
                  list = this.assetConfig.secondGroupList;
                  elem = 'secondGroupList';
                  this.assetConfig.secondGroupList = [];
                  break;
                case 'enableThirdGroup':
                  list = this.assetConfig.thirdGroupList;
                  elem = 'thirdGroupList';
                  this.assetConfig.thirdGroupList = [];
                  break;
              }
            list.forEach(element => {
                this.removeFromAssetList(element.value, elem);    
            });
        }
    }
}
